// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"50000":"e8dec7efcdc6dc08","74724":"b6323009d4472833","90012":"d47e4f3ff15ec2c4","95868":"6438dbb375600f1b"}[chunkId] + ".css";
};